module.exports = __webpack_public_path__ + "img/15.cae79489.jpg";